import React from 'react';
import { MailIcon } from 'lucide-react';
export function Header() {
  return <header className="w-full py-6 px-4 md:px-8 max-w-7xl mx-auto flex justify-between items-center" data-id="element-75">
      <div className="flex items-center" data-id="element-76">
        <img src="https://cdn.magicpatterns.com/uploads/2owrsuFxpnjj62oPqiekvz/image_1.png" alt="Lighthouse Capital Group" className="h-12 md:h-16 w-auto object-contain" data-id="element-77" />
      </div>

      <a href="mailto:jack.bennett@lhcapitalgroup.com" className="hidden md:flex items-center text-gray-500 hover:text-brand-green transition-colors text-sm font-medium" data-id="element-78">
        <MailIcon className="w-4 h-4 mr-2" data-id="element-79" />
        jack.bennett@lhcapitalgroup.com
      </a>
    </header>;
}